import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { LIST_ROW_HEIGHTS } from '../../../../constants/list_row_heights';
import { IListRowRenderProps, ITeam } from '../../../../data/types';

import { List } from '../../../shared/List/List';
import { ListAvatar } from '../../../shared/List/ListAvatar';
import { ListItem, ListItemCell } from '../../../shared/List/ListItem';
import { NoResults } from '../../../shared/NoResults';
import { ManageTeamPopup } from './ManageTeamPopup';

interface IProps extends RouteComponentProps {
  loading: boolean;
  teams: ITeam[];
  isAdmin: boolean;
  selectedTeamId: string;
  onTeamChange: (id: string) => void;
  filterApplied: boolean;
  clearFilter: () => void;
  isMobile: boolean;
}

export const TeamList = withRouter((props: IProps): React.ReactElement => {
  const [initialIndex, setInitialIndex] = React.useState<number>();

  /**
   * @description sets the initial index to scroll to on first render
   */
  React.useEffect((): void => {
    const selectedIndex = props.teams?.findIndex((item: ITeam): boolean => {
      return item.id === props.selectedTeamId;
    });
    setInitialIndex(selectedIndex);
  }, [props.isMobile ? props.selectedTeamId : null]);

  /**
   * @description render function for list items
   * @param param0
   */
  const rowRenderer = ({
    index,
    key,
    style,
  }: IListRowRenderProps): React.ReactElement => {
    const team = props.teams[index];

    return (
      <TeamListItem
        style={style}
        team={team}
        key={key}
        onClick={(): void => props.onTeamChange(team.id)}
        selected={props.selectedTeamId === team.id}
      />
    );
  };

  return props.teams.length ? (
    <List
      rowHeight={LIST_ROW_HEIGHTS.normal}
      rowRenderer={rowRenderer}
      listLength={props.teams.length}
      scrollTo={initialIndex}
    />
  ) : (
    <NoResults
      message='No Teams Found'
      filterApplied={props.filterApplied}
      clearFilter={props.clearFilter}
    />
  );
});

interface IListItemProps {
  team: ITeam;
  onClick: (id: string) => void;
  style: React.CSSProperties;
  selected: boolean;
}

const TeamListItem = (props: IListItemProps): React.ReactElement => {
  const clickHandler = (): void => props.onClick(props.team.id);
  return (
    <ListItem
      onClick={clickHandler}
      style={props.style}
      selected={props.selected}
    >
      <ListItemCell style={{ minWidth: 0, overflow: 'hidden', flex: 2 }}>
        <ListAvatar entity={props.team} />
      </ListItemCell>
      <ListItemCell>
        <ManageTeamPopup team={props.team} />
      </ListItemCell>
    </ListItem>
  );
};
